import { useState } from 'react';
import { Modal, Button } from './ui';
import { Database, MapPin, Eye, Wrench } from 'lucide-react';
import type { ReactNode } from 'react';
import { DatenschutzModal, ImpressumModal } from './LegalModals';

export function AboutModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [dsOpen, setDsOpen] = useState(false);
  const [impOpen, setImpOpen] = useState(false);
  return (
    <Modal open={open} onClose={onClose} title="Über diese App"
      footer={<Button variant="primary" onClick={onClose}>Schließen</Button>}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div className="auth-logo" style={{ margin: 0 }}><img src="/logo.png" alt="" /></div>
          <div>
            <div className="t-title-3">Mitgliederverwaltung</div>
            <div className="text-tertiary" style={{ fontSize: 13 }}>Union DSG Gaspoltshofen · v1.2.0 (Juli 2026)</div>
          </div>
        </div>

        <Block icon={<Database size={15} />} title="Was wird hier gespeichert?">
          Alle Mitglieder mit Name, Adresse, Kontaktdaten, Mitgliedsart und Sektionszugehörigkeit.
          Bankdaten werden bewusst nicht erfasst.
        </Block>
        <Block icon={<MapPin size={15} />} title="Wo werden die Daten gespeichert?">
          Auf Servern in der Europäischen Union, DSGVO-konform. Niemals in den USA,
          niemals auf privaten Geräten der Entwickler.
        </Block>
        <Block icon={<Eye size={15} />} title="Wer kann was sehen?">
          <ul style={{ margin: '4px 0 0', paddingLeft: 18, display: 'flex', flexDirection: 'column', gap: 3 }}>
            <li>Obmann / Kassier: alle Mitglieder aller Sektionen</li>
            <li>Sektionsleiter: nur die eigene Sektion</li>
            <li>Mitglieder selbst: kein Login, kein Zugriff auf das System</li>
          </ul>
        </Block>
        <Block icon={<Wrench size={15} />} title="Technische Betreuung">
          Maximilian Huber (Obmann) · <span className="t-mono">support@union-gaspoltshofen.at</span>
        </Block>

        <div style={{ display: 'flex', gap: 16, fontSize: 13 }}>
          <button onClick={() => setDsOpen(true)} className="text-accent" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: 'inherit' }}>Datenschutzerklärung</button>
          <button onClick={() => setImpOpen(true)} className="text-accent" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: 'inherit' }}>Impressum</button>
        </div>
      </div>
      <DatenschutzModal open={dsOpen} onClose={() => setDsOpen(false)} />
      <ImpressumModal open={impOpen} onClose={() => setImpOpen(false)} />
    </Modal>
  );
}

function Block({ icon, title, children }: { icon: ReactNode; title: string; children: ReactNode }) {
  return (
    <div style={{ display: 'flex', gap: 12 }}>
      <div style={{ width: 32, height: 32, borderRadius: 8, background: 'var(--bg-muted)', color: 'var(--text-secondary)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
        {icon}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, marginBottom: 2 }}>{title}</div>
        <div className="text-secondary" style={{ fontSize: 13, lineHeight: 1.5 }}>{children}</div>
      </div>
    </div>
  );
}
